module.exports = __webpack_public_path__ + "static/media/Data Structures using C.59bf43c9.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CSE/Data Structures using C.pdf
// module id = 99
// module chunks = 0